// extracted by mini-css-extract-plugin
module.exports = {"container":"UserPurchaseDetails_container__3W1Ms","goBack":"UserPurchaseDetails_goBack__2y6j_"};